import {BaseFormModel} from './base-form-model';

export class WifiPrinter extends BaseFormModel<WifiPrinter> {
    id: number;
    name: string;
    type: string;
    ipAddress: string;
    columns: number;
    emulation: string;
    sortOrder: number;
    orgId: number;
}
